<template>
  <div>
    <p>Sample Componet {{ testMsg }}</p>
  </div>
</template>
<script>
export default {
  name: "sample_component",
  props: {
    testMsg: String,
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
